import {styled, Breakpoints} from '@vw-marketing/us-components';

interface NavigationWrapperProps {
  hideOnMobile?: boolean;
}

export const NavigationButtonWrapper: any = styled.div<NavigationWrapperProps>`
  ${(props: NavigationWrapperProps) =>
    props.hideOnMobile
      ? `display: none;
        @media (min-width: ${Breakpoints.b560}px) {
            display: block;
        }`
      : ''}
`;

export const PageNumberWrapper: any = styled.div``;
